import { Component, OnInit } from '@angular/core';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { DataService } from 'app/shared/services/data/data.service';
import { SportySkyService } from 'app/shared/services/sportySky/sporty-sky.service';


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent extends SubscriptionBaseComponent implements OnInit {

  // map;

  lat: number;
  long: number;
  map: string;

  constructor(
    private dataService: DataService,
    private sportySkyService: SportySkyService
  ) {
    super();
  }

  ngOnInit(): void {
    // this.initSub();
    this.getSportySky();
  }

  // ngAfterViewInit(): void {
  //   this.initMap();
  //   // this.initiGeo();
  // }

  private getSportySky(): void {
    this.sportySkyService.getAllByDepartement().subscribe(res => {
      this.map = res.departmentMap.file.contentUrl;
    });
  }


}

